import React, { useEffect, useState } from 'react';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { initFincode } from "@fincode/js"
import ApiFetch from '../ApiFetch';
import { useLocation, useNavigate } from 'react-router';
import LoadingButton from '@mui/lab/LoadingButton';

const CardRegist = () => {
    function registCard(token){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/card",{token:token}).then((r)=>{
            return r.json()
        })
    }
    const [fincode,setFincode] = useState(null)
    const [cardNo,setCardNo] = useState("")
    const [expireY,setExpireY] = useState("")
    const [expireM,setExpireM] = useState("")
    const [holderName,setHolderName] = useState("")
    const [securityCode,setSecurityCode] = useState("")
    const [registStart,setRegistStart] = useState(false)
    const navigate = useNavigate()

  useEffect(() => {
    // 外部スクリプトの読み込み
    const script = document.createElement('script')
    script.src = 'https://js.test.fincode.jp/v1/fincode.js'
    script.async = true
    document.body.appendChild(script)

    // スクリプトが読み込まれた後に関数を実行
    script.onload = () => {
        let fincode = window.Fincode("p_test_M2U2ZGQ4ZmItMmM2OC00ZjNiLWI1ZTEtOTJlMzcxNTYzNTAzZjgwODI1MmYtZmQ2NC00NDQ4LWFmM2EtYzA4MTkzZmM4OTk0c18yNDAxMjA5MDI0OQ"); // windowオブジェクトを介して関数にアクセス
        setFincode(fincode)
    };

    // コンポーネントがアンマウントされたときにスクリプトをクリーンアップ
    return () => {
      document.body.removeChild(script);
    };
  }, []); // useEffectの第2引数には依存関係のない空の配列を渡す

  function submitBk(){
    const card = {
        customer_id: "c_o1tb3X_5TV2Ui76y1hO81Q",
        default_flag: "1",
        card_no : cardNo,              // カード番号
        expire : expireY.padStart(2,"0") + expireM.padStart(2,"0"),// カード有効期限(yymm)
        holder_name: holderName,       // カード名義人
        security_code: securityCode,   // セキュリティコード
    }
    fincode.cards(card,(status,response) => {
        if(200 === status){
            console.log(response)
        } else {
            alert(response.errors.map(d => d.error_message).join("\r\n"))
        }
    },() => {
        // 通信エラー
       console.log("通信エラー") 
    })
  }
  function submit(){
    setRegistStart(true)
    if(holderName.length === 0){
        setRegistStart(false)
        alert("カード名義人が入力されていません。")
        return
    }
    if(securityCode.length === 0){
        setRegistStart(false)
        alert("セキュリティコードが入力されていません。")
        return
    }
    const card = {
        card_no : cardNo,              // カード番号
        expire : expireY.padStart(2,"0") + expireM.padStart(2,"0"),// カード有効期限(yymm)
        holder_name: holderName,       // カード名義人
        security_code: securityCode,   // セキュリティコード
        number: 1
    }
    fincode.tokens(card,(status,response) => {
        if(200 === status){
            console.log(response.list[0].token)
            registCard(response.list[0].token).then(r => {
                if(r.result){
                  if(r.data.redirect_url !== ""){
                    window.location.href = r.data.redirect_url
                  } else {
                    window.location.href = "/manage/payment"
                  }
                } else {
                    setRegistStart(false)
                    alert(r.errors)
                }
            })
        } else {
            alert(response.errors.map(d => d.error_message).join("\r\n"))
            setRegistStart(false)
        }
    },() => {
        // 通信エラー
       console.log("通信エラー") 
    })
  }
  return (
    <Card
      variant="outlined"
      sx={{
        maxHeight: 'max-content',
        maxWidth: '100%',
        mx: 'auto',
        // to make the demo resizable
        overflow: 'auto',
        resize: 'horizontal',
      }}
    >
      <Typography level="title-lg" startDecorator={<InfoOutlined />}>
        カード登録
      </Typography>
      <Divider inset="none" />
      <CardContent
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(80px, 1fr))',
          gap: 1.5,
        }}
      >
        <FormControl sx={{ gridColumn: '1/-1' }}>
          <FormLabel>カード番号(Card number)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={cardNo} onChange={(e) => {setCardNo(e.target.value)}}  />
        </FormControl>
        <FormControl>
          <FormLabel>有効期限[月] (MM)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={expireM} onChange={(e) => setExpireM(e.target.value)} />
        </FormControl>
        <FormControl>
          <FormLabel>有効期限[年] (YY)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={expireY} onChange={(e) => setExpireY(e.target.value)} />
        </FormControl>
        <FormControl>
          <FormLabel>セキュリティコード(CVC/CVV)</FormLabel>
          <Input endDecorator={<InfoOutlined />} value={securityCode} onChange={(e) => setSecurityCode(e.target.value)} />
        </FormControl>
        <FormControl sx={{ gridColumn: '1/-1' }}>
          <FormLabel>カード名義人(Card holder name)</FormLabel>
          <Input placeholder="フルネームで入力(Enter cardholder's full name)" value={holderName} onChange={(e) => setHolderName(e.target.value)} />
        </FormControl>
        <CardActions sx={{ gridColumn: '1/-1' }}>
            {registStart ? <LoadingButton loading variant="outlined">登録</LoadingButton> : 
          (<Button variant="solid" color="primary" onClick={() => submit()}>
            登録
          </Button>)}
        </CardActions>
      </CardContent>
    </Card>
  );
};

export default CardRegist;